module.exports = __webpack_public_path__ + "9488d02b/img/comment-question-icon.7dd26e04.svg";